<!-- 上传 -->
<nz-upload [nzBeforeUpload]="beforeUpload" [nzName]="nzName" [nzListType]="nzListType" [(nzFileList)]="fileList"
  [nzShowButton]="fileList.length < 8" [nzPreview]="handlePreview" (nzChange)="removeStatus($event)"
  [nzDisabled]="nzDisabled" [nzShowButton]="nzShowButton" [nzRemove]='nzShowButton' [nzDownload]="download"
  [nzShowUploadList]="nzShowUploadList">
  <ng-container *ngIf="isImageStatus; else elseTemplate">
    <!-- 上传图片 -->
    <div>
      <em nz-icon nzType="plus"></em>
      <div style="margin-top: 8px">Upload</div>
    </div>
  </ng-container>
  <!-- 上传文件 -->
  <ng-template #elseTemplate>
    <button nz-button [disabled]="disabled"><em nz-icon nzType="upload"></em> Click to Upload</button>
  </ng-template>
</nz-upload>
<nz-modal [nzVisible]="previewVisible" [nzContent]="modalContent" [nzFooter]="null"
  (nzOnCancel)="previewVisible = false">
  <ng-template #modalContent style="display: inline-block;">
    <img alt="" [src]="previewImage" style="width: 100%; "/>
  </ng-template>
</nz-modal>